
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as _ from 'underscore';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import PageBase from "../PageBase.vue";
import { stepInfoType } from "@/types/Application";


@Component({
    components:{
        PageBase
    }
})
export default class RflmQuestionnaire extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;
    
    currentStep = 0;
    currentPage = 0;

    selectedCounterApplications = []; 

    mounted(){
        this.selectedCounterApplications = [];
        this.reloadPageInformation();        
    }

    public reloadPageInformation() {   
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        
        if (this.step.result?.selectedCounterApplications) {
            this.selectedCounterApplications = this.getSelectedCounterApplicationNames(this.step.result?.selectedCounterApplications)           
        } else {
            this.selectedCounterApplications = [];
        }
        
        const progress = 100;        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }   

    public getSelectedCounterApplicationNames(selectedApps){
        
        const result = []
        
        for(const form of selectedApps){
            if(form=='newParentingArrangements')   result.push('New Parenting Arrangements');
            if(form=='newChildSupport')            result.push('New Child Support');
            if(form=='newContactWithChild')        result.push('New Contact With a Child');
            if(form=='guardianOfChild')            result.push('Guardian Of a Child');
            if(form=='newSpousalSupport')          result.push('New Spousal Support');
            if(form=='newCompanionAnimal')         result.push('New Companion Animal');
            if(form=='existingParentingArrangements')   result.push('Existing Parenting Arrangements');
            if(form=='existingChildSupport')            result.push('Existing Child Support');
            if(form=='existingContactWithChild')        result.push('Existing Contact With a Child');
            if(form=='existingSpousalSupport')          result.push('Existing Spousal Support');
            if(form=='existingCompanionAnimal')         result.push('Existing Companion Animal');
        }       
        
        return result;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();       
    }
    
    beforeDestroy() {
        const progress = 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
    }
}
